module.exports = __webpack_public_path__ + "static/hk-jewel-b85f0451aaece49804cf663dd0c8e7ae.png";